import styled from 'styled-components';

const SelectedMenu = styled.div`
   min-width: 2px;
   border-radius: 40px;
   margin-right: 10px;
   background: #EBECF0;
   overflow: hidden;
`;


export default SelectedMenu;